import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { useFreeSignupInfo } from 'src/modules/product/hooks/useFreeSignupInfo';
import { Alert } from 'src/shared/components/alert';
import { Loader } from 'src/shared/components/loader';
export function FreeSignupAlert() {
    const { watch } = useFormContext();
    const { user } = useHostContext();
    const isPublicModule = watch('publicModule');
    const { isFreeSignupAllowed, offerPrice, isLoadingOffer } = useFreeSignupInfo(isPublicModule);
    const shouldShowLoader = isLoadingOffer && isPublicModule && isFreeSignupAllowed === false && !user.isAttendant;
    if (shouldShowLoader) {
        return _jsx(Loader, { className: "my-8", "data-testid": "free-signup-alert-loader" });
    }
    const shouldShowAlert = isPublicModule && isFreeSignupAllowed === false && Boolean(offerPrice) && !user.isAttendant;
    if (shouldShowAlert) {
        return (_jsx(Alert, { className: "mb-4", children: _jsx(Trans, { i18nKey: "modules.form.free_module.info", values: { offerPrice } }) }));
    }
    return null;
}
